<template>
  <div class="circlefollowbox">
    <van-sticky>
      <div class="circletabbox">
        <ul class="circleul">
          <li :class="liindex==0 ? 'active' : '' " @click="gotourl(0)"><span>推荐</span></li>
          <li :class="liindex==1 ? 'active' : '' " @click="gotourl(1)"><span>关注</span></li>
          <li :class="liindex==2 ? 'active' : '' " @click="gotourl(2)"><span>最近访问</span></li>
        </ul>
      </div>

      <div class="followtitlebox">
        <div class="followtitle">我的关注</div>
      </div>
    </van-sticky>
    <div class="followmain">

      <div class="nofollowbox" v-if="nomyfollowcircle">
        <div class="nofollowpic"><img src="../../assets/images/circle_icon_wu.png" /></div>
        <div class="gotofollow" @click="gotocirclelist"><button>立即去关注</button></div>
      </div>

      <div v-else>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">

          <div class="circle-cell" v-for="(item,index) in myfollowcircle" :key="index">
            <div class="circle-cell-pic" @click="gotocirclecontent(item.id)">
              <img :src="item.avatar_url" />
            </div>
            <div class="circle-cell-name" @click="gotocirclecontent(item.id)">
              <div class="cname">{{item.title}}</div>
              <div class="cconner">{{item.content}}</div>
            </div>
            <div class="circle-cell-fllow">
              <div class="signinbox" v-if="item.is_checkin==0" @click="singinclick(item.id)">
                <div class="signinimg"><img src="../../assets/images/circle_btn_sign_selected.png" /></div>
                <p class="signintext">签到</p>
              </div>

              <div class="signinbox" v-else>
                <div class="signinimg"><img src="../../assets/images/circle_btn_sign_normal.png" /></div>
                <p class="signintext active">已签</p>
              </div>

            </div>

          </div>

        </van-list>

      </div>

    </div>

  </div>

</template>

<script>
import { getfollowcircle, gettoSignincircle } from "../../api/api";
import { Toast } from "vant";
export default {
  data () {
    return {
      myfollowcircle: [], //我关注的圈子
      nomyfollowcircle: true,
      liindex: 1,
      loading: false,
      finished: false,
      page: 0,
      pageCount: 0,
      titlename: '我的关注'
    };
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == 'circlecontent') {
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },
  created () {

    this.changetabbar();
  },
  mounted () {
    document.title = this.titlename;
    let that = this;
    Toast.loading({
      mask: true,
      message: '加载中...'
    });
    getfollowcircle().then(res => {
      if (res.data.code == 200) {
        that.myfollowcircle = res.data.data.list;
        that.pageCount = res.data.data.pageCount;
        Toast.clear();
        if (res.data.data.list == []) {
          that.nomyfollowcircle = true;
        } else {
          that.nomyfollowcircle = false;
        }
        that.finished = false;
        that.loading = false;
      } else {
        Toast.fail('加载失败，请刷新！');
      }
    }).catch(err => {
      Toast.clear();
    });
  },
  methods: {
    gotocirclecontent (id) {
      this.$router.push({
        path: '/circlecontent',
        query: {
          id: id
        }
      })


    },
    //加载更多
    onLoad () {
      // 异步更新数据

      var page = this.page;
      let that = this;
      let pageCount = this.pageCount;
      page++;
      if (page > pageCount) {
        return;
      }
      this.page = page;
      setTimeout(() => {
        getfollowcircle(page).then(res => {
          if (res.data.code == 200) {
            this.loading = false;
            let myfollowarr = that.myfollowcircle;
            let newarr = res.data.data.list;
            newarr.forEach(function (e) {
              myfollowarr.push(e);
            });
            this.finished = true;
          }
        }).catch(err => {
          if (err == 412) {
            this.loading = false;
            this.finished = true;
          }
        });;
      }, 500);
    },
    singinclick (item_id) {
      var that = this;
      var show; //传递到数据库点赞的状态

      if (localStorage.getItem("qiandao")) {
        var cookie_mid = localStorage.getItem("qiandao").split(",");
      } else {
        var cookie_mid = [];
      }
      var newmessage = [];

      for (var i = 0; i < that.myfollowcircle.length; i++) {
        if (that.myfollowcircle[i].id == item_id) {
          //遍历找到对应的id

          var num = that.myfollowcircle[i].is_checkin; //当前
          var isshow; //点赞的状态
          if (cookie_mid.includes(item_id)) {
            //说明已经点过赞,取消赞

            for (var j = 0; j < cookie_mid.length; j++) {
              if (cookie_mid[j] == item_id) {
                cookie_mid.splice(j, 1); //删除取消赞的mid
              }
            }
            --num;
            isshow = 0; //点赞的状态
            that.myfollowcircle[i].is_checkin = num;
            localStorage.setItem("qiandao", cookie_mid.join(","));
          } else {
            isshow = 1; //点赞的状态
            ++num;
            that.myfollowcircle[i].is_checkin = num;
            cookie_mid.unshift(item_id); //新增赞的mid
            localStorage.setItem("qiandao", cookie_mid.join(","));
          }
        }
      }

      gettoSignincircle(item_id).then(res => {
        if (res.code == 200) {
          Toast({
            message: res.message,
            icon: "success"
          });
        } else {
          Toast.fail("关注失败！");
        }
      });
    },

    gotocirclelist () {
      this.$router.push({
        name: "circlelist"
      });
    },

    gotourl: function (liindex) {
      switch (liindex) {
        case 0:
          this.$router.push({ name: "circlelist" });
          //this.liindex = 0;
          break;
        case 1:
          this.$router.push({ name: "circlefollow" });
          //this.liindex = 1;
          break;
        case 2:
          this.$router.push({ name: "circlevisit" });
          //this.liindex = 2;
          break;
      }
    },
    changetabbar: function () {
      //判断当前的路由所在区域给
      this.onPath = this.$route.path;
      if (this.onPath == "/circlevisit") {
        this.liindex = 2;
      } else if (this.onPath == "/circlefollow") {
        this.liindex = 1;
      } else if (this.onPath == "/circlelist") {
        this.liindex = 0;
      }
    }
  },
  activated () {
    this.page = 0;
    let that = this;
    getfollowcircle().then(res => {
      if (res.data.code == 200) {
        that.myfollowcircle = res.data.data.list;
        that.pageCount = res.data.data.pageCount;
        Toast.clear();
        if (res.data.data.list == []) {
          that.nomyfollowcircle = true;
        } else {
          that.nomyfollowcircle = false;
        }
      } else {
        Toast.fail('加载失败，请刷新！');
      }
    });

  }
};
</script>

<style scoped>
.circlefollowbox {
  background: #fff;
  height: 100%;
}
.circlefollowbox .followtitlebox {
  background: #fff;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.35rem;
}
.circlefollowbox .followtitle {
  font-size: 0.8108108108108109rem;
  border-left: 0.2702702702702703rem solid #ffbd0a;
  padding-left: 0.5405405405405406rem;
  font-weight: bold;
  color: #333;
  margin-left: 0.9459459459459459rem;
  background: #fff;
}
.circlefollowbox .followmain {
  padding-left: 0.9459459459459459rem;
  padding-right: 0.7027027027027027rem;
  padding-bottom: 3rem;
}

.circlefollowbox .circle-cell {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.8108108108108109rem;
  border-bottom: 0.02702702702702703rem solid #f6f6f6;
  width: 100%;
}
.circlefollowbox .circle-cell .circle-cell-pic {
  width: 2.16rem;
  height: 2.16rem;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
  position: relative;
}
.circlefollowbox .circle-cell .circle-cell-pic .circle-cell-pic-no {
  position: absolute;
  bottom: 0;
  background: rgba(218, 135, 70, 0.9);
  height: 0.7027027027027027rem;
  line-height: 0.7027027027027027rem;
  width: 2.16rem;
  color: #fff;
  font-size: 0.4864864864864865rem;
  text-align: center;
  border-radius: 0 0 0.2702702702702703rem 0.2702702702702703rem;
}
.circlefollowbox .circle-cell .circle-cell-pic img {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
}
.circlefollowbox .circle-cell .circle-cell-pic .circle-cell-pic-no img {
  width: 0.7567567567567568rem;
  height: 0.5675675675675675rem;
}
.circlefollowbox .circle-cell .circle-cell-pic .circle-cell-pic-no01 {
  background: rgba(246, 210, 84, 0.9);
  color: #eb7c3a;
}
.circlefollowbox .circle-cell .circle-cell-pic .circle-cell-pic-no02 {
  background: rgba(211, 224, 241, 0.9);
  color: #7a98b4;
}
.circlefollowbox .circle-cell .circle-cell-pic .circle-cell-pic-no03 {
  background: rgba(238, 147, 120, 0.9);
  color: #b04b32;
}
.circlefollowbox .circle-cell .circle-cell-name {
  flex: 8;
  padding-right: 0.2702702702702703rem;
  padding-left: 0.5rem;
}
.circlefollowbox .circle-cell .circle-cell-name .cname {
  font-size: 0.7567567567567568rem;
}
.circlefollowbox .circle-cell .circle-cell-name .cconner {
  font-size: 0.65rem;
  color: #999999;
  padding-top: 0.32rem;
}
.circlefollowbox .circle-cell .circle-cell-name .ctext1 {
  font-size: 0.6486486486486487rem;
  color: #999999;
}
.circlefollowbox .circle-cell .circle-cell-name .ctext2 {
  font-size: 0.6486486486486487rem;
  color: #999999;
  padding-left: 0.5405405405405406rem;
}
.circlefollowbox .circle-cell .circle-cell-fllow {
  float: 3.5;
}
.circlefollowbox .circle-cell .circle-cell-fllow button {
  font-size: 0.6216216216216216rem;
  background: #ffbd0a;
  border: none;
  width: 3.2432432432432434rem;
  height: 1.35rem;
  border-radius: 5px;
  display: block;
  color: #fff;
  padding: 0;
}
.circlefollowbox .circle-cell .circle-cell-fllow button.active {
  background: #dbdbdb;
  border: none;
}

.circlefollowbox .circle-cell .circle-cell-fllow {
  padding-top: 0.2702702702702703rem;
  flex: 1 1 1.5rem;
  width: 1.5rem;
}
.circlefollowbox .circle-cell .circle-cell-fllow .signinbox {
}
.circlefollowbox .circle-cell .circle-cell-fllow .signinbox .signinimg {
  text-align: center;
  margin-bottom: -0.1rem;
}
.circlefollowbox .circle-cell .circle-cell-fllow .signinbox .signinimg img {
  width: 0.972972972972973rem;
  height: 1.027027027027027rem;
}
.circlefollowbox .circle-cell .circle-cell-fllow .signinbox .signintext {
  text-align: center;
  font-size: 0.62rem;
  color: #6699ff;
}
.circlefollowbox .circle-cell .circle-cell-fllow .signinbox .signintext.active {
  color: #afaeae;
}

.nofollowbox {
  padding-top: 7.837837837837838rem;
}
.nofollowbox .nofollowpic {
  text-align: center;
}
.nofollowbox .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nofollowbox .gotofollow {
  padding-top: 1.2702702702702702rem;
  text-align: center;
}
.nofollowbox .gotofollow button {
  width: 5.405405405405405rem;
  height: 1.8918918918918919rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  font-size: 0.7rem;
  color: #fff;
  border: none;
  border-radius: 1rem;
  margin: 0 auto;
}
.circletabbox {
  background: #fff;
}
.circletabbox .circleul {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #efefef;
  padding: 0 1.2rem;
  padding-top: 0.5rem;
}
.circletabbox .circleul li {
  font-size: 0.81rem;
  text-align: center;
  color: #666666;
  flex: 0 0 33.333%;
}
.circletabbox .circleul li span {
  padding: 0.5rem 0;
  display: inline-block;
}
.circletabbox .circleul li.active {
  color: #ffbd0a;
}
.circletabbox .circleul li.active span {
  border-bottom: 3px solid #ffbd0a;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/circlefollow.vue